module.exports = __webpack_public_path__ + "static/media/floor_concrete_steelWire.1712b1a8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_concrete_steelWire.png
 ** module id = 950
 ** module chunks = 0
 **/